var FormService = /** @class */ (function () {
    function FormService() {
    }
    FormService.prototype.isErrorState = function (control, form) {
        var isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    };
    return FormService;
}());
export { FormService };
